import React, { Component } from "react";
import Card from "@material-ui/core/Card";
import CardActionArea from "@material-ui/core/CardActionArea";
import {
  Grid,
  Button,
  Dialog,
  DialogContent,
  CircularProgress,
} from "@material-ui/core";
import {
  CalendarToday,
  QueryBuilder,
  MonetizationOn,
  Room,
  Person,
} from "@material-ui/icons";
import moment from "moment";
import { navigate } from "../../actions/routerResolve";
import { connect } from "react-redux";
import ColorService from "../../tools/ColorsService";
import ModalStatus from "./ModalStatus";
import MissionService from "../../tools/MissionService";
import FlightStageService from "../../tools/FlightStageService";
import { msgSimple } from "../../actions/snackbarActions";
//SweetAlert
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import {
  allowAutorizar,
  closedStatus,
  denyEditProfiles,
  MISSION_STATUS,
  PROFILE_STATUS,
} from "../../enums";
import { constants } from "../../config";
import { colors } from "../../styles";

const MySwal = withReactContent(Swal);

class CardShuttle extends Component {
  constructor(props) {
    super(props);
    this.state = {
      created_by: this.props.created_by || {},
      stages: [],
      openStatusModal: false,
      modal: {
        selectedStatus: "",
      },
      loading: false,
      status: this.props.status,
    };
    this.profile = JSON.parse(
      localStorage.getItem(constants.userKey)
    ).user.profile;
    this.flight_stages = (this.props.flight_stages || []).sort((a, b) => {
      const dateA = a.departure_date ? moment(a.departure_date) : moment(0);
      const dateB = b.departure_date ? moment(b.departure_date) : moment(0);

      const timeA = a.local_time ? a.local_time : "00:00";
      const timeB = b.local_time ? b.local_time : "00:00";

      const dateTimeA = dateA.set({
        hour: parseInt(timeA.split(":")[0]),
        minute: parseInt(timeA.split(":")[1]),
      });

      const dateTimeB = dateB.set({
        hour: parseInt(timeB.split(":")[0]),
        minute: parseInt(timeB.split(":")[1]),
      });

      return dateTimeA - dateTimeB;
    });
  }

  componentWillMount = () => {
    let { flight_stages, status, flight_denomination } = this.props;
    if (status !== "Finalizado") {
      let aux = (flight_stages || []).filter(
        (element) =>
          element.status !== "Finalizado" && element.status !== "Cancelado"
      );
      if (aux.length) {
        flight_stages = aux;
      }
    }
    this.setState({ stages: flight_stages });
    this.setState({
      modal: {
        selectedStatus:
          flight_stages && flight_stages.length > 0
            ? flight_stages[0].status
            : "",
      },
    });
    if (flight_denomination) {
      this.setState({ modal: { missionName: flight_denomination } });
    }
  };

  handleAuthorizeMission = (mission) => {
    console.log("authorize");
  };

  handleValidation = (aircraft, aircraft_type) => {
    if (aircraft && aircraft_type) {
      if (
        aircraft_type.type &&
        aircraft.aircraft_model.icao_model &&
        aircraft.marks
      )
        return (
          <span>
            {" "}
            {aircraft_type.type} <br /> {aircraft.aircraft_model.icao_model}{" "}
            <br /> {aircraft.marks}{" "}
          </span>
        );
      else if (aircraft_type.type && aircraft.aircraft_model.icao_model)
        return (
          <span>
            {" "}
            {aircraft_type.type} <br /> {aircraft.aircraft_model.icao_model}{" "}
          </span>
        );
      else if (aircraft_type.type) return <span> {aircraft_type.type} </span>;
    } else if (aircraft)
      return (
        <span>
          {" "}
          {aircraft.aircraft_model.icao_model}
          <br />
          {aircraft.marks}{" "}
        </span>
      );
    else if (aircraft_type) return <span>{aircraft_type.type}</span>;
    return <span>?</span>;
  };

  openStatusModal = () => {
    if (denyEditProfiles.includes(this.profile)) {
      //usuário sem permisão
      return false;
    }
    this.setState({ modal: { id: this.props.id } });
    this.setState({ openStatusModal: !this.state.openStatusModal });
  };

  closeStatusModal = () => {
    this.setState({ openStatusModal: !this.state.openStatusModal });
    this.setState({ modal: null });
  };

  _handleIdMultiSelectNG = async (value) => {
    if (value) {
      return await value.map((element) => {
        if (element.users)
          return {
            value: element.id,
            label: element.name,
            groups: element.users,
          };
        else return { value: element.id, label: element.name };
      });
    }
    return null;
  };
  _handleIdMultiSelectU = async (value) => {
    if (value) {
      return await value.map((element) => {
        return {
          value: element.id,
          label:
            element.war_name +
            " - " +
            (element.first_name ? element.first_name : "") +
            " " +
            (element.last_name ? element.last_name : ""),
        };
      });
    }
    return null;
  };

  _handleIdMultiSelectSaveNG = async (value) => {
    if (value) {
      var listGrupo = [];
      let list = [];
      let list1 = [];
      await value.map((element) => {
        if (element.groups) {
          element.groups.map((el) => {
            list1.push(el.id);
          });
        } else list1.push(element.value);
      });

      listGrupo = listGrupo.concat(list1);
      return list;
    }
    return null;
  };

  _handleIdMultiSelect = async (value) => {
    // console.log('value:',value)
    if (value) {
      let list = await value.map((element) => element.value);
      return list;
    }
    return null;
  };

  handleTime = async (value) => {
    if (value === "") {
      return null;
    } else {
      return value;
    }
  };

  handleDate = async (value) => {
    if (value) {
      return moment(value).format("YYYY-MM-DD");
    }
    return null;
  };

  handleSaveNewStatus = (status) => {
    Swal.fire({
      title: "Deseja realmente alterar o status da missão?",
      html: "<p>Esse é o status geral da missão, para alterar o status da etapa, você precisa ajustar diretamente na etapa.</p>",
      type: "info",
      customClass: "{ z-index: 1000000 }",
      customContainerClass: "{ z-index: 100000 }",
      showCloseButton: true,
      showCancelButton: true,
      focusConfirm: false,
      confirmButtonText: '<i class="fa fa-thumbs-up"></i> Sim',
      confirmButtonAriaLabel: "Sim",
      cancelButtonText: '<i class="fa fa-thumbs-down"></i> Não',
      cancelButtonAriaLabel: "Não",
    }).then(async (result) => {
      if (!!result.value) {
        // this.props.status = status;
        // let item = JSON.parse(JSON.stringify(this.props)).flight_stages[0]; //the first mission
        let item = this.getInProgressStage(); //the stage_main mission
        item.status = status;
        this.setState({ loading: true });
        if (item.passengers) {
          item.passengers = item.passengers.map((item) => item.id);
        }
        FlightStageService.update(item.id, item).then((result) => {
          this.setState({ loading: false });
          if (result.ok) {
            MySwal.fire({
              title: "<p>Status salvo com sucesso!</p>",
              type: "success",
            });
            this.updateStatusMission(status);
            this.setState({ openStatusModal: false });
          } else {
            MySwal.fire({
              title: "<p>Erro ao salvar Status!</p>",
              type: "error",
            });
          }
        });
      }
    });
  };

  updateStatusMission = async (newStatus, showConfirmation = true) => {
    let responseDialog = {};
    if (showConfirmation) {
      responseDialog = await Swal.fire({
        title: "Deseja realmente alterar o status da missão?",
        html: "<p>Esse é o status geral da missão, para alterar o status da etapa, você precisa ajustar diretamente na etapa.</p>",
        type: "info",
        customClass: "{ z-index: 1000000 }",
        customContainerClass: "{ z-index: 100000 }",
        showCloseButton: true,
        showCancelButton: true,
        focusConfirm: false,
        confirmButtonText: '<i class="fa fa-thumbs-up"></i> Sim',
        confirmButtonAriaLabel: "Sim",
        cancelButtonText: '<i class="fa fa-thumbs-down"></i> Não',
        cancelButtonAriaLabel: "Não",
      });
    }

    if (responseDialog.value || !showConfirmation) {
      MissionService.getById(this.props.id).then((result) => {
        if (result.ok) {
          let list = result.response.flight_stages.map((el) => el.id);
          let listIdNotificationGroups =
            result.response.notification_groups.map((ng) => ng.id);
          // console.log('resposta da atualização da missão:', { ...result.response, status: newStatus, flight_stages: list })

          let mission = {
            ...result.response,
            status: newStatus,
            flight_stages: list,
            notification_groups: listIdNotificationGroups,
          };
          MissionService.update(this.props.id, mission).then((resultUpdate) => {
            if (resultUpdate.ok) {
              console.log("update misson: ", resultUpdate);
              MySwal.fire({
                title: "<p>Operação realizada com sucesso.</p>",
                type: "success",
              });
              let flight_stages = result.response.flight_stages;
              let status = result.response.status;
              if (status !== "Finalizado") {
                let aux = flight_stages.filter(
                  (element) =>
                    element.status !== "Finalizado" &&
                    element.status !== "Cancelado"
                );
                if (aux.length) {
                  flight_stages = aux;
                }
              }
              this.setState({ stages: flight_stages });
            } else {
              MySwal.fire({
                title:
                  "<p>Ocorreu um erro ao executar essa operação, tente novamente.!</p>",
                type: "error",
              });
            }
          });
        }
      });
    }

    // Swal.fire({
    //   title: "Deseja realmente alterar o status da missão?",
    //   html: "<p>Esse é o status geral da missão, para alterar o status da etapa, você precisa ajustar diretamente na etapa.</p>",
    //   type: "info",
    //   customClass: "{ z-index: 1000000 }",
    //   customContainerClass: "{ z-index: 100000 }",
    //   showCloseButton: true,
    //   showCancelButton: true,
    //   focusConfirm: false,
    //   confirmButtonText: '<i class="fa fa-thumbs-up"></i> Sim',
    //   confirmButtonAriaLabel: "Sim",
    //   cancelButtonText: '<i class="fa fa-thumbs-down"></i> Não',
    //   cancelButtonAriaLabel: "Não",
    // }).then(async (result) => {
    //   if (result.value) {

    //   }
    // });
  };

  getInProgressStage = () => {
    const stages = (this.props.flight_stages || []).sort((a, b) => {
      const dateA = a.departure_date ? moment(a.departure_date) : moment(0);
      const dateB = b.departure_date ? moment(b.departure_date) : moment(0);

      const timeA = a.local_time ? a.local_time : "00:00";
      const timeB = b.local_time ? b.local_time : "00:00";

      const dateTimeA = dateA.set({
        hour: parseInt(timeA.split(":")[0]),
        minute: parseInt(timeA.split(":")[1]),
      });

      const dateTimeB = dateB.set({
        hour: parseInt(timeB.split(":")[0]),
        minute: parseInt(timeB.split(":")[1]),
      });

      return dateTimeA - dateTimeB;
    });
    if (stages.length === 1) {
      return stages[0];
    } else {
      const inProgressStage = stages.filter(
        (item) => !closedStatus.includes(item.status)
      );
      if (!inProgressStage.length) {
        return stages[0];
      }
      return inProgressStage[0];
    }
  };

  render() {
    return (
      <Grid item xs={12} sm={6} md={4} lg={4} xl={3}>
        <Dialog open={this.state.loading}>
          <DialogContent>
            <CircularProgress></CircularProgress>
          </DialogContent>
        </Dialog>
        <ModalStatus
          openModal={this.state.openStatusModal}
          handleUpdateStatusMission={this.updateStatusMission}
          closeStatusModal={this.closeStatusModal}
          modal={this.state.modal}
          stages={this.props.flight_stages}
          status={this.getInProgressStage().status}
          allPermission={this.profile === PROFILE_STATUS.ADMINISTRACAO}
          createdBy={this.state.created_by}
          statusMission={this.state.status}
          missionId={this.props.id}
        />
        <Card className="hover-screen-card" style={styles.card}>
          <CardActionArea style={{ width: "100%", height: "100%" }}>
            <Grid
              container
              style={{
                height: "100%",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <Grid
                container
                item
                md={12}
                style={{
                  fontFamily: "Roboto",
                  justifyContent: "center",
                  alignItems: "center",
                  textAlign: "center",
                  margin: 0,
                  padding: 5,
                  minHeight: 58,
                }}
                onClick={() => this.props.navigate("/flight/" + this.props.id)}
              >
                <Grid
                  container
                  item
                  md={4}
                  sm={4}
                  xm={12}
                  style={{
                    justifyContent: "center",
                    textAlign: "center",
                    alignItems: "center",
                    paddingRight: 5,
                  }}
                >
                  <b>
                    <span>
                      {this.props.flight_denomination
                        ? this.props.flight_denomination.toUpperCase()
                        : "NÃO DEFINIDO"}
                    </span>
                  </b>
                </Grid>
                <Grid item md={4} sm={4}>
                  {/* <Flight style={{ fontSize: 10 }} /><br /> */}
                  {/* {this.props.aircraft_type? this.props.aircraft_type.type:false || this.props.aircraft?this.props.aircraft.aircraft_model.icao_model:false || this.props.aircraft? this.props.aircraft.marks:false? <span>{this.props.aircraft_type.type.toUpperCase()}<br />{this.props.aircraft.aircraft_model.icao_model} <br />{this.props.aircraft.marks}</span> :'?'} */}
                  {this.handleValidation(
                    this.props.aircraft,
                    this.props.aircraft_type
                  )}
                </Grid>
                <Grid
                  container
                  justify={"center"}
                  alignItems={"center"}
                  item
                  md={4}
                  sm={4}
                  xm={12}
                  style={{
                    fontFamily: "Roboto",
                    alignItems: "center",
                    textAlign: "center",
                    margin: 0,
                  }}
                  onClick={() =>
                    this.props.navigate("/flight/" + this.props.id)
                  }
                >
                  <MonetizationOn style={{ fontSize: 15 }} />
                  <span
                    style={{
                      alignItems: "center",
                      fontSize: 13,
                      fontWeight: "500",
                    }}
                  >
                    {this.props.cost_center.name}
                  </span>
                </Grid>
              </Grid>
              {this.props.flight_stages &&
              this.props.flight_stages.length > 0 ? (
                <Grid
                  style={{
                    borderRadius: "8px 8px 0 0",
                    padding: 10,
                    marginRight: 4,
                    marginLeft: 4,
                    backgroundColor:
                      this.props.flight_denomination === "EM MANUTENÇÃO"
                        ? colors.red500
                        : ColorService.backgroundColor(
                            this.getInProgressStage().status
                          ),
                    color: ColorService.contrastColor(
                      this.getInProgressStage().status
                    ),
                  }}
                  container
                  item
                  md={12}
                  alignContent="center"
                  justify="center"
                >
                  <Grid
                    item
                    container
                    direction="column"
                    justify="center"
                    alignItems="center"
                    xs={4}
                    md={4}
                    style={{ fontFamily: "Roboto", textAlign: "center" }}
                    onClick={() =>
                      this.props.navigate("/flight/" + this.props.id)
                    }
                  >
                    <div>
                      <h3 style={{ margin: 0 }}>
                        {this.getInProgressStage().from
                          ? this.getInProgressStage().from
                          : "?"}
                      </h3>
                    </div>
                    <div>
                      <h3 style={{ margin: 0 }}>
                        {this.getInProgressStage().origin
                          ? this.getInProgressStage().origin
                          : ""}
                      </h3>
                    </div>
                  </Grid>
                  <Grid
                    item
                    container
                    justify="center"
                    alignItems="center"
                    xs={3}
                    md={3}
                    style={{
                      padding: 4,
                      marginRight: 4,
                      marginLeft: 4,
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                  >
                    <img
                      src={ColorService.image(this.getInProgressStage().status)}
                      style={{ maxWidth: 80 }}
                      onClick={() =>
                        this.props.navigate("/flight/" + this.props.id)
                      }
                    />
                    {/* <span style={{ padding: 2, paddingLeft: 10, paddingRight: 10, backgroundColor: ColorService.contrastColor(this.getInProgressStage().status), color: ColorService.backgroundColor(this.getInProgressStage().status), borderRadius: 3, fontSize: 10 }}  onClick={() => this.props.navigate('/flight/' + this.props.id)}></span> */}
                    {/* <Button
                      variant="contained"
                      color="primary"
                      style={{
                        paddingLeft: 5,
                        paddingRight: 5,
                        marginTop: 10,
                        backgroundColor: ColorService.contrastColor(
                          this.getInProgressStage().status
                        ),
                        color: ColorService.backgroundColor(
                          this.getInProgressStage().status
                        ),
                      }}
                      onClick={this.openStatusModal}
                    >
                      {this.getInProgressStage().status === "EmAndamento"
                        ? "Em Andamento"
                        : this.getInProgressStage().status}
                    </Button> */}
                  </Grid>
                  <Grid
                    container
                    direction="column"
                    justify="center"
                    alignItems="center"
                    item
                    xs={4}
                    md={4}
                    style={{ fontFamily: "Roboto", textAlign: "center" }}
                    onClick={() =>
                      this.props.navigate("/flight/" + this.props.id)
                    }
                  >
                    <div>
                      <h3 style={{ margin: 0 }}>
                        {this.getInProgressStage().to
                          ? this.getInProgressStage().to
                          : "?"}
                      </h3>
                    </div>
                    {/* <br/> */}
                    <div>
                      <h3 style={{ margin: 0 }}>
                        {this.getInProgressStage().destination
                          ? this.getInProgressStage().destination
                          : ""}
                      </h3>
                    </div>
                  </Grid>
                </Grid>
              ) : null}
              <Grid
                container
                direction="row"
                style={{
                  borderRadius: "0 0 8px 8px",
                  padding: 10,
                  marginRight: 4,
                  marginLeft: 4,
                  backgroundColor:
                    this.props.flight_denomination === "EM MANUTENÇÃO"
                      ? colors.red500
                      : ColorService.backgroundColor(
                          this.getInProgressStage().status
                        ),
                  color: ColorService.contrastColor(
                    this.getInProgressStage().status
                  ),
                  minHeight: "40%",
                }}
                onClick={() => this.props.navigate("/flight/" + this.props.id)}
              >
                <Grid item md={4}>
                  <CalendarToday
                    style={{ marginRight: 3, fontSize: 14, fontWeight: "400" }}
                  />
                  <span>
                    {this.getInProgressStage().date
                      ? moment(this.getInProgressStage().date)
                          .format("DD/MMM/YYYY")
                          .toUpperCase()
                      : "?"}
                  </span>
                  <br />
                  <QueryBuilder
                    style={{
                      marginTop: 7,
                      fontSize: 14,
                      fontWeight: "400",
                      alignItems: "center",
                    }}
                  />
                  {this.getInProgressStage() ? (
                    this.getInProgressStage().local_time ? (
                      <span>
                        {" "}
                        Local:{" "}
                        {this.getInProgressStage().local_time.split(":")[0] +
                          ":" +
                          this.getInProgressStage().local_time.split(":")[1]}
                      </span>
                    ) : (
                      <span>{" --:-- "}</span>
                    )
                  ) : (
                    <span>{" --:-- "}</span>
                  )}
                </Grid>
                <Grid item md={4}></Grid>
                <Grid item md={4}>
                  <CalendarToday
                    style={{ marginRight: 3, fontSize: 14, fontWeight: 400 }}
                  />
                  <span>
                    {this.getInProgressStage().arrival_date
                      ? moment(this.getInProgressStage().arrival_date)
                          .format("DD/MMM/YYYY")
                          .toUpperCase()
                      : "?"}
                  </span>
                  <br />
                  <QueryBuilder
                    style={{
                      marginTop: 7,
                      fontSize: 14,
                      fontWeight: 400,
                      alignItems: "center",
                    }}
                  />
                  {this.getInProgressStage() ? (
                    this.getInProgressStage().arrival_time ? (
                      <span>
                        {" "}
                        Local:{" "}
                        {this.getInProgressStage().arrival_time.split(":")[0] +
                          ":" +
                          this.getInProgressStage().arrival_time.split(":")[1]}
                      </span>
                    ) : (
                      <span>{" --:-- "}</span>
                    )
                  ) : (
                    <span>{" --:-- "}</span>
                  )}
                </Grid>
                <div style={{ marginTop: "8px" }}>
                  <Person
                    style={{ marginRight: 3, fontSize: 14, fontWeight: 400 }}
                  ></Person>
                  <span>{`Solicitante: ${
                    this.state.created_by.first_name || ""
                  } ${this.state.created_by.last_name || ""}`}</span>
                </div>
              </Grid>
              {/* <Grid container item md={12} style={{ textAlign: 'center', alignItems: 'center', marginTop: 3 }}>
                                <Grid item md={12} style={{ justifyContent: 'center' }} >
                                        <span>
                                            {this.props.aircraft? this.props.aircraft.aircraft_model.icao_model: '?'}<br/>{this.props.aircraft? this.props.aircraft.marks:''}
                                        </span>
                                </Grid>
                            </Grid>
                            <Grid container item md={12} direction='row' >
                                <Grid item md={4} style={{ alignItems: 'center' }} >
                                </Grid>
                                <Grid item md={4} style={{ textAlign: 'center',justifyItems:'center',padding:7 }}>
                                    {this.props.aircraft_type && this.props.aircraft ? this.props.aircraft_type.type || this.props.aircraft.aircraft_model.icao_model || this.props.aircraft.marks ? <span >{this.props.aircraft.marks}</span> : false : ''}
                                </Grid>
                                <Grid item md={4} style={{ alignItems: 'center' }} >
                                </Grid>
                            </Grid> */}
              <Grid
                container
                justify="flex-start"
                style={{ minHeight: 117 }}
                onClick={() => this.props.navigate("/flight/" + this.props.id)}
              >
                {/* <Grid container justify='flex-start' item md={6} >
                                    <Lens style={{ fontSize: 14 }} />
                                    <span style={{ marginLeft: 6 }}>{'Voo ' + this.props.status}</span>
                                </Grid> */}
                {this.state.stages.length > 1 &&
                  this.state.stages.map((element, index) => {
                    if (index !== 0)
                      return (
                        <Grid
                          key={index}
                          item
                          md={4}
                          style={{
                            backgroundColor: "#f1f1f1",
                            justifyContent: "center",
                            alignItems: "center",
                            textAlign: "center",
                          }}
                        >
                          <div
                            style={{
                              marginBottom: 3,
                              marginRight: 2,
                              backgroundColor: "white",
                              padding: 4,
                              height: "98%",
                              alignItems: "space-between",
                            }}
                          >
                            <div
                              style={{
                                height: "40%",
                                justifyItems: "center",
                                flexDirection: "column",
                              }}
                            >
                              <Room style={{ fontSize: 10 }} />
                              <span style={{ marginLeft: 6, fontSize: 11 }}>
                                {element.to ? element.to : "?"}
                              </span>
                              <br></br>
                              <span style={{ marginLeft: 6, fontSize: 11 }}>
                                {element.destination
                                  ? element.destination
                                  : "?"}
                              </span>
                            </div>
                            <div style={{ height: "20%" }}>
                              <CalendarToday style={{ fontSize: 10 }} />
                              <span style={{ marginLeft: 6, fontSize: 11 }}>
                                {element.date
                                  ? moment(element.date)
                                      .format("DD/MMM/YYYY")
                                      .toUpperCase()
                                  : "?"}
                              </span>
                            </div>
                            <div style={{ height: "20%" }}>
                              <QueryBuilder style={{ fontSize: 10 }} />
                              <span style={{ marginLeft: 6, fontSize: 11 }}>
                                {element.local_time
                                  ? element.local_time.split(":")[0] +
                                    ":" +
                                    element.local_time.split(":")[1]
                                  : " --:-- "}{" "}
                              </span>
                            </div>
                            <div
                              style={{
                                alignItems: "center",
                                height: "20%",
                                marginBottom: 4,
                                paddingBottom: 12,
                              }}
                            >
                              <span
                                style={{
                                  fontSize: 10,
                                  marginLeft: 6,
                                  padding: 2,
                                  paddingLeft: 10,
                                  paddingRight: 10,
                                  backgroundColor: ColorService.backgroundColor(
                                    element.status
                                  ),
                                  borderRadius: 3,
                                  color: ColorService.contrastColor(
                                    element.status
                                  ),
                                }}
                              >
                                {element.status}
                              </span>
                            </div>
                          </div>
                        </Grid>
                      );
                  })}
              </Grid>
            </Grid>
          </CardActionArea>
          {!denyEditProfiles.includes(this.profile) && (
            <div style={{ width: "100%", padding: 10 }}>
              <Button
                onClick={this.openStatusModal}
                style={{
                  width: "inherit",
                  color: "white",
                  backgroundColor: colors.primary_dark,
                }}
              >
                Atualizar Status
              </Button>
            </div>
          )}
        </Card>
      </Grid>
    );
  }
}

const mapStateToProps = (state) => ({
  users: state.usersReducer.users,
});

const mapDispatchToProps = {
  msgSimple,
  navigate,
};

export default connect(mapStateToProps, mapDispatchToProps)(CardShuttle);

const styles = {
  card: {
    // height: 250
  },
  media: {
    // ⚠️ object-fit is not supported by IE11.
    objectFit: "cover",
  },
};



// WEBPACK FOOTER //
// ./src/routes/home/Card.js